// extracted by mini-css-extract-plugin
export default {"homeInput":"ProjectHomePersonalizationPage_homeInput__jP6-1","card":"ProjectHomePersonalizationPage_card__cKOWI"};